import { FormattedMessage } from 'react-intl';

import { cn } from '@/lib/utils';
import type { TranslationKeys } from '@/lib/translations/types';

interface IntegrationTabsProps {
  categories: { categoryTitle: TranslationKeys; count: number }[];
  selectedCategory: TranslationKeys | 'all';
  onCategoryChange: (category: TranslationKeys | 'all') => void;
}

export const IntegrationTabs = ({
  categories,
  selectedCategory,
  onCategoryChange,
}: IntegrationTabsProps): JSX.Element => {
  const totalCount = categories.reduce((sum, { count }) => sum + count, 0);

  return (
    <div className="border-b border-gray-200 dark:border-gray-700">
      <nav className="-mb-px flex space-x-8 overflow-x-auto">
        <button
          onClick={() => onCategoryChange('all')}
          className={cn(
            'whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm transition-colors',
            selectedCategory === 'all'
              ? 'border-blue-500 text-blue-600 dark:text-blue-400'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300',
          )}
        >
          <FormattedMessage id="integrations.tabs.all" />
          {totalCount > 0 && (
            <span className="ml-2 bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400 py-0.5 px-2 rounded-full text-xs">
              {totalCount}
            </span>
          )}
        </button>
        {categories.map(({ categoryTitle, count }) => (
          <button
            key={categoryTitle}
            onClick={() => onCategoryChange(categoryTitle)}
            className={cn(
              'whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm transition-colors',
              selectedCategory === categoryTitle
                ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300',
            )}
          >
            <FormattedMessage id={categoryTitle} />
            {count > 0 && (
              <span className="ml-2 bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400 py-0.5 px-2 rounded-full text-xs">
                {count}
              </span>
            )}
          </button>
        ))}
      </nav>
    </div>
  );
};
